// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import { docodeHexResponse } from '../../../_common/common.utils';
import FamilyActionType from './family-details.types';

const INITIAL_STATE = {
	// Family Member Count Data
	familyMemberCountData: null,
	// Family Member Income Response
	familyMemberIncomeResponse: null,
	// Family Member List Array
	familyMemberListArr: [],
	// Fetch Family Member Array
	fetchFamilyMemberArr: [],
	// Fetch Family Member Response
	fetchFamilyMemberResp: null,
	// Add Family Member Response
	addFamilyMemberResp: null,
	// Fetch Particular Family Member Array
	fetchParticularFamilyMemberArr: null,
	// Fetch Particular Family Member Response
	fetchParticularFamilyMemberResp: null,
	// Delete Family Member Response
	deleteFamilyMemberResp: null,
	// Verify Family Aadhar OTP Response
	verifyFamilyAadharOtpResp: null,
	// Verify Family Aadhar OTP Result
	verifyFamilyAadharOtpResult: [],
	// Verify Validate Family Aadhar OTP Response
	verifyValidateFamilyAadharOtpResp: null,
	// Verify Validate Family Aadhar OTP Result
	verifyValidateFamilyAadharOtpResult: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** FAMILY MEMBER COUNT DATA START *********************** */
		case FamilyActionType.FAMILY_MEMBER_COUNT_CHANGED:
			return { ...state, familyMemberCountData: action.payload };
		/** ***************** FAMILY MEMBER COUNT DATA END *********************** */

		/** ***************** FAMILY MEMBER INCOME START *********************** */
		case FamilyActionType.FAMILY_MEMBER_INCOME_SUCCESS:
			return { ...state, familyMemberIncomeResponse: action.payload };

		case FamilyActionType.FAMILY_MEMBER_INCOME_FAILURE:
			return { ...state, familyMemberIncomeResponse: action.payload };

		case FamilyActionType.FAMILY_MEMBER_INCOME_RESPONSE_CHANGED:
			return { ...state, familyMemberIncomeResponse: null };

		/** ***************** FAMILY MEMBER INCOME END *********************** */

		/** ***************** FAMILY MEMBER LIST ARRAY START *********************** */
		case FamilyActionType.SET_FAMILY_MEMBER_ARR_START:
			return { ...state, familyMemberListArr: action.payload };

		/** ***************** FAMILY MEMBER LIST ARRAY END *********************** */

		/** ***************** FETCH FAMILY MEMBER START *********************** */
			case FamilyActionType.FETCH_FAMILY_MEMBERS_SUCCESS:
			return {
				...state,
				fetchFamilyMemberResp: action.payload,
				fetchFamilyMemberArr: docodeHexResponse(action.payload, 'FetchMemberDataKey'),
			};

		case FamilyActionType.FETCH_FAMILY_MEMBERS_FAILURE:
			return { ...state, fetchFamilyMemberResp: action.payload };

		case FamilyActionType.FETCH_FAMILY_MEMBERS_RESPONSE_CHANGED:
			return { ...state, fetchFamilyMemberResp: null };

		/** ***************** FETCH FAMILY MEMBER END *********************** */

		/** ***************** ADD FAMILY MEMBER START *********************** */
		case FamilyActionType.ADD_FAMILY_MEMBERS_SUCCESS:
			return { ...state, addFamilyMemberResp: action.payload };

		case FamilyActionType.ADD_FAMILY_MEMBERS_FAILURE:
			return { ...state, addFamilyMemberResp: action.payload };

		case FamilyActionType.ADD_FAMILY_MEMBERS_RESPONSE_CHANGED:
			return { ...state, addFamilyMemberResp: null };

		/** ***************** ADD FAMILY MEMBER END *********************** */

		/** ***************** FETCH PARTICULAR FAMILY MEMBER START *********************** */
		case FamilyActionType.FETCH_PARTICULAR_FAMILY_MEMBERS_SUCCESS:
			return {
				...state,
				fetchParticularFamilyMemberResp: action.payload,
				fetchParticularFamilyMemberArr: docodeHexResponse(
					action.payload,
					'FetchMemberDataKey',
				),
			};

		case FamilyActionType.FETCH_PARTICULAR_FAMILY_MEMBERS_FAILURE:
			return { ...state, fetchParticularFamilyMemberResp: action.payload };

		case FamilyActionType.FETCH_PARTICULAR_FAMILY_MEMBERS_RESPONSE_CHANGED:
			return { ...state, fetchParticularFamilyMemberResp: action.payload };

		case FamilyActionType.FETCH_PARTICULAR_FAMILY_MEMBERS_OBJ_RESET:
			return { ...state, fetchParticularFamilyMemberArr: null };

		/** ***************** FETCH PARTICULAR FAMILY MEMBER END *********************** */

		/** ***************** DELETE FAMILY MEMBER START *********************** */
		case FamilyActionType.DELETE_FAMILY_MEMBERS_SUCCESS:
			return { ...state, deleteFamilyMemberResp: action.payload };

		case FamilyActionType.DELETE_FAMILY_MEMBERS_FAILURE:
			return { ...state, deleteFamilyMemberResp: action.payload };

		case FamilyActionType.DELETE_FAMILY_MEMBERS_RESPONSE_CHANGED:
			return { ...state, deleteFamilyMemberResp: null };

		/** ***************** DELETE FAMILY MEMBER END *********************** */

		/** ***************** VERIFY FAMILY AADHAR OTP START *********************** */
		case FamilyActionType.VERIFY_FAMILY_AADHAR_OTP_SUCCESS:
			return {
				...state,
				verifyFamilyAadharOtpResp: action.payload,
				verifyFamilyAadharOtpResult: docodeHexResponse(action.payload, 'AppVerifyKYCKey'),
			};

		case FamilyActionType.VERIFY_FAMILY_AADHAR_OTP_FAILURE:
			return { ...state, verifyFamilyAadharOtpResp: action.payload };

		case FamilyActionType.VERIFY_FAMILY_AADHAR_OTP_RESPONSE_CHANGED:
			return { ...state, verifyFamilyAadharOtpResp: null };

		/** ***************** VERIFY FAMILY AADHAR OTP END *********************** */

		/** ***************** VERIFY VALIDATE FAMILY AADHAR OTP START *********************** */
		case FamilyActionType.VERIFY_VALIDATE_FAMILY_AADHAR_OTP_SUCCESS:
			return {
				...state,
				verifyValidateFamilyAadharOtpResp: action.payload,
				verifyValidateFamilyAadharOtpResult: docodeHexResponse(
					action.payload,
					'AppVerifyKYCKey',
				),
			};

		case FamilyActionType.VERIFY_VALIDATE_FAMILY_AADHAR_OTP_FAILURE:
			return { ...state, verifyValidateFamilyAadharOtpResp: action.payload };

		case FamilyActionType.VERIFY_VALIDATE_FAMILY_AADHAR_OTP_RESPONSE_CHANGED:
			return { ...state, verifyValidateFamilyAadharOtpResp: null };

		/** ***************** VERIFY VALIDATE FAMILY AADHAR OTP END *********************** */

		default:
			return state;
	}
};
